export default __webpack_public_path__ + "static/media/icons.32267f3b.ttf";